import {
  OfflineBudgetNestedTableRowData,
  TableHeader,
} from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';
import { formatNumberWithSpaces } from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/formatNumberWithSpaces';
import {
  TableCell,
  TableRow,
  Typography,
  Table,
  TableHead,
  TableBody,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import TvTouchpointTableRow from 'pages/calculator/MediaPlanning/common/BudgetTable/OfflineBudgetTable/NestedBudgetTable/TvTouchpointTableRow';
import OutdoorsTouchpointTableRow from 'pages/calculator/MediaPlanning/common/BudgetTable/OfflineBudgetTable/NestedBudgetTable/OutdoorsTouchpointTableRow';

interface NestedBudgetTableProps {
  rowData?: OfflineBudgetNestedTableRowData[];
  touchpoint?: string;
}

function NestedBudgetTable({ rowData, touchpoint }: NestedBudgetTableProps) {
  const { t } = useTranslation();

  const getTableHeaders = (): TableHeader[] => {
    switch (touchpoint) {
      case 'tv':
        return [
          { key: 'mediaPlanning.copy', align: 'left', width: '250px' },
          { key: '', align: 'left' },
          { key: '', align: 'left' },
          { key: 'mediaPlanning.grp', align: 'right' },
          { key: 'mediaPlanning.split', align: 'right' },
          { key: 'mediaPlanning.weeks', align: 'right' },
          { key: 'mediaPlanning.budget', align: 'right' },
        ];
      case 'outdoor':
        return [
          { key: 'mediaPlanning.type', align: 'left', width: '250px' },
          { key: 'mediaPlanning.option', align: 'left' },
          { key: 'mediaPlanning.budget', align: 'right' },
        ];
      default:
        return [
          { key: 'mediaPlanning.type', align: 'left' },
          { key: 'mediaPlanning.budget', align: 'right' },
        ];
    }
  };

  return (
    <Table size="small" sx={{ tableLayout: 'fixed' }}>
      <TableHead>
        <TableRow>
          {getTableHeaders()?.map((header) => (
            <TableCell
              key={header.key}
              align={header.align}
              sx={{ width: header.width || 'auto' }}
            >
              <Typography
                variant="caption"
                textTransform="uppercase"
                fontWeight={600}
              >
                {t(header.key)}
              </Typography>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rowData?.map((nestedRow) => {
          if (touchpoint === 'tv') {
            return <TvTouchpointTableRow key={nestedRow.id} row={nestedRow} />;
          }

          if (touchpoint === 'outdoor') {
            return (
              <OutdoorsTouchpointTableRow key={nestedRow.id} row={nestedRow} />
            );
          }

          return (
            <TableRow key={nestedRow.id}>
              <TableCell>
                <Typography variant="body2" textTransform="capitalize">
                  {nestedRow.type}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2">
                  {`${formatNumberWithSpaces(
                    nestedRow.budget.value.toFixed(0)
                  )} ${nestedRow.budget.currency}`}
                </Typography>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default NestedBudgetTable;
